import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  generalData: {
    fields: {
      incidentType: false,
      isVerifiedToReport: false,
      insuranceCategories: [],
    },
  },
};
const generalDataSlice = createSlice({
  name: 'generalData',
  initialState,
  reducers: {
    setGeneralData(state, action) {
      const { point, data } = action.payload;
      state.generalData.fields[point] = data;
    },
    setInsuranceCategories(state, action) {
      const { data } = action.payload;
      state.generalData.fields.insuranceCategories = data;
    },
  },
});
export const { setGeneralData, setInsuranceCategories } = generalDataSlice.actions; // imported in file.js
const generalDataReducer = generalDataSlice.reducer; // store.js setup
export default generalDataReducer;
